<script>
  import { createEventDispatcher } from "svelte";
  import {External} from "../external";

  export let items = [],
    activeItem = null,
    getLabel = (item) => {
      return item ? item.label || item.name || item.title : "-";
    },
    innerClass = "";
  let clz = "";
  export { clz as class };


  export function setItems(newItems) {
    this.items = newItems;
  }

  export function addItems(newItems) {
    this.items.push(...newItems);
  }

  const dispatch = createEventDispatcher();

  let onClick = (event) => {
    External.Tools.showFloatingPopupList({
      target: External.$(event.target),
      items: items,
      getLabel: getLabel,
      onSelect: function (selected) {
        activeItem = selected;
        dispatch("change", {
          selected: selected
        });
      }
    });
  };

  $: activeItemLabel = getLabel(activeItem);
</script>

<div class="custom-dropdown {clz}">
  <div class="flex align-center custom-dropdown-button circle-effect {innerClass}" on:click={(ev) => onClick(ev)}>
    {activeItemLabel} <span class="material-icons"> keyboard_arrow_down </span>
  </div>
</div>
